import * as React from "react";
import type { FC } from "react";
import { css } from "@emotion/react";

import { HorizontalAlign } from "../SimpleTable/HorizontalAlign";

interface GridProps {
    gap?: number;
    baseline?: boolean;
    top?: boolean;
    children: readonly React.ReactNode[];
}

const grid = (baseline: boolean, top: boolean, gap: number) =>
    css(
        {
            display: "flex",
            maxWidth: "100%",
            width: "100%",
            gap: gap,
        },
        baseline && { alignItems: "baseline" },
        top && { alignItems: "flex-start" }
    );

const SIZE_TOKEN = 8;

export const Grid: FC<GridProps> = ({ baseline = false, top = false, gap = 0.5, children }) => {
    const styles = grid(baseline, top, gap * SIZE_TOKEN);
    return <div css={styles}>{children}</div>;
};

const column = (size: number, horizontalAlign: undefined | HorizontalAlign, textTopPadding: boolean) =>
    css({
        flexGrow: size,
        flexShrink: 0,
        flexBasis: 0,
        margin: -2,
        padding: 2,
        paddingTop: 2 + (textTopPadding ? 7 : 0),
        overflow: "hidden",
        textAlign: horizontalAlign,
        "&:last-child": {
            paddingRight: "0",
            marginRight: "0",
        },
    });

interface GridColumnProps {
    size?: number;
    horizontalAlign?: HorizontalAlign;
    textTopPadding?: boolean;
    children: readonly React.ReactNode[];
}

export const GridColumn: FC<GridColumnProps> = ({ horizontalAlign, size = 1, textTopPadding = false, children }) => {
    const styles = column(size, horizontalAlign, textTopPadding);
    return <div css={styles}>{children}</div>;
};
